const getters = {
  getAccessToken: state => {
    return state.authStatus.accessToken
  },
  getUserId: state => {
    return state.user.id
  },
  userFullname: state => {
    return `${state.user.firstName} ${state.user.lastName}`
  },
  getErrorMessage: state => {
    return state.authStatus.errorMessage
  },
  getRefreshToken: state => {
    return state.authStatus.refreshToken
  },
  hasLoginError: state => {
    return state.authStatus.authError
  }
}

export default getters
